import styled from "styled-components";
import { ReactComponent as DragMenu } from "../../../../../../app/newLayout/assets/svgIcon/listView/dragmenu.svg";

export const StyledEditColumnsShell = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
`;

export const StyledEditColumnsBody = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
`;

export const StyledEditColumnsBodyLeft = styled.div`
  border-right: 1px solid #e9edf5;
  display: flex;
  flex-direction: column;
  min-height: 0;
  width: 50%;
  padding: 12px 16px;
`;

export const StyledEditColumnsBodyRight = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;
  width: 50%;
  padding: 12px 16px;
`;

export const ElementHeading = styled.h6`
  color: var(--GREY, #4a4a68);
  font-size: 10px;
  font-weight: 400;
  line-height: 22px;
  margin: 0;
`;

export const ColumnListWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
  margin: 4px 0;
  min-height: 0;
  overflow-y: auto;
`;

export const ColumnElement = styled.label`
  align-items: center;
  cursor: pointer;
  display: flex;
  gap: 8px;
  padding: 0 6px;
`;

export const DragItemIconSVG = styled(DragMenu)`
  flex-shrink: 0;
  height: 11px;
  width: 15px;
`;

export const ColumnInput = styled.input`
  border-radius: 2px;
  border: 1px solid var(--LIGHT-GREY, #8c8ca1);
  margin: 0;
`;

export const StyledUpdateETANote = styled.p`
  margin: 0 0 8px;
  color: #4a4a68;
  font-size: 13px;
  line-height: 18px;
`;

export const StyledUpdateETADiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: var(--GREY, #4a4a68);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;

  .ant-picker {
    border-radius: 4px;
    border: 1px solid var(--LIGHT-ASH, #b9b9c6);
    height: 32px;
    input {
      font-family: Inter;
      color: var(--GREY, #4a4a68);
      font-weight: 400;
      line-height: 22px;
      background-color: var(--Cloud, #fcfdfe);
    }
  }
`;
